/**
 * 二手车列表页
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 二手车列表
Mock.mock(/used-car\/cars\/all/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'used_cars': [{
      'brand': '本田',
      'come_from': '车主',
      'created_at': '2016-10-19 14:37',
      'id': 16,
      'logo_url': 'https://assets-cdn.cheanjia.com/public/auto-logos/1.0.0/logo_100018.jpg',
      'model': '哥瑞 2016款 1.5L CVT经典版',
      'publisher': '车主测试',
      'status_code': 4,
      'updated_at': '2016-10-19 14:38'
    }, {
      'brand': '奥迪',
      'come_from': '快修店',
      'created_at': '2016-10-19 14:33',
      'id': 15,
      'logo_url': 'https://assets-cdn.cheanjia.com/public/auto-logos/1.0.0/logo_100004.jpg',
      'model': '奥迪A6L 2016款 TFSI 舒适型',
      'publisher': '测试',
      'status_code': 4,
      'updated_at': '2016-10-19 14:34'
    }, {
      'brand': '别克',
      'come_from': '车主',
      'created_at': '2016-10-19 13:55',
      'id': 14,
      'logo_url': 'https://assets-cdn.cheanjia.com/public/auto-logos/1.0.0/logo_100021.jpg',
      'model': '昂科威 2016款 20T 两驱领先型',
      'publisher': 'jh',
      'status_code': 4,
      'updated_at': '2016-10-19 13:55'
    }, {
      'brand': '宝马',
      'come_from': '车主',
      'created_at': '2016-10-19 11:43',
      'id': 12,
      'logo_url': 'https://assets-cdn.cheanjia.com/public/auto-logos/1.0.0/logo_100007.jpg',
      'model': '宝马3系 2016款 320i 时尚型',
      'publisher': '一二三',
      'status_code': 4,
      'updated_at': '2016-10-19 11:46'
    }, {
      'brand': '奔驰',
      'come_from': '快修店',
      'created_at': '2016-10-19 11:44',
      'id': 13,
      'logo_url': 'https://assets-cdn.cheanjia.com/public/auto-logos/1.0.0/logo_100016.jpg',
      'model': '奔驰C级 2015款 C 200 运动版',
      'publisher': '贺强强强',
      'status_code': 4,
      'updated_at': '2016-10-19 11:45'
    }, {
      'brand': '宝马',
      'come_from': '快修店',
      'created_at': '2016-10-18 17:43',
      'id': 11,
      'logo_url': 'https://assets-cdn.cheanjia.com/public/auto-logos/1.0.0/logo_100007.jpg',
      'model': '宝马2系旅行车 2016款 218i 时尚型',
      'publisher': '发个',
      'status_code': 4,
      'updated_at': '2016-10-18 17:44'
    }, {
      'brand': '奥迪',
      'come_from': '快修店',
      'created_at': '2016-10-18 17:29',
      'id': 9,
      'logo_url': 'https://assets-cdn.cheanjia.com/public/auto-logos/1.0.0/logo_100004.jpg',
      'model': '奥迪A6L 2016款 TFSI 舒适型',
      'publisher': '测试',
      'status_code': 4,
      'updated_at': '2016-10-18 17:43'
    }, {
      'brand': '比亚迪',
      'come_from': '车主',
      'created_at': '2016-10-18 17:32',
      'id': 10,
      'logo_url': 'https://assets-cdn.cheanjia.com/public/auto-logos/1.0.0/logo_100019.jpg',
      'model': '比亚迪F0 2015款 1.0L 悦酷型',
      'publisher': '一二三',
      'status_code': 3,
      'updated_at': '2016-10-18 17:42'
    }, {
      'brand': '宝马',
      'come_from': '快修店',
      'created_at': '2016-10-18 17:28',
      'id': 8,
      'logo_url': 'https://assets-cdn.cheanjia.com/public/auto-logos/1.0.0/logo_100007.jpg',
      'model': '宝马X1 2015款 sDrive18i 领先晋级版',
      'publisher': '一二三',
      'status_code': 1,
      'updated_at': '2016-10-18 17:28'
    }, {
      'brand': '本田',
      'come_from': '车主',
      'created_at': '2016-10-18 17:26',
      'id': 7,
      'logo_url': 'https://assets-cdn.cheanjia.com/public/auto-logos/1.0.0/logo_100018.jpg',
      'model': '杰德 2016款 1.8L CVT豪华版 5座',
      'publisher': '王意义',
      'status_code': 1,
      'updated_at': '2016-10-18 17:26'
    }, {
      'brand': '奥迪',
      'come_from': '快修店',
      'created_at': '2016-10-18 17:25',
      'id': 6,
      'logo_url': 'https://assets-cdn.cheanjia.com/public/auto-logos/1.0.0/logo_100004.jpg',
      'model': '奥迪A3 2014款 Sportback 35 TFSI 自动进取型',
      'publisher': '前面',
      'status_code': 1,
      'updated_at': '2016-10-18 17:25'
    }, {
      'brand': '纳智捷',
      'come_from': '快修店',
      'created_at': '2016-10-18 17:23',
      'id': 5,
      'logo_url': 'https://assets-cdn.cheanjia.com/public/auto-logos/1.0.0/logo_100104.jpg',
      'model': '大7 SUV 2015款 2.2T 四驱智尊型',
      'publisher': '测试',
      'status_code': 1,
      'updated_at': '2016-10-18 17:23'
    }, {
      'brand': '宝骏',
      'come_from': '快修店',
      'created_at': '2016-10-18 17:22',
      'id': 4,
      'logo_url': 'https://assets-cdn.cheanjia.com/public/auto-logos/1.0.0/logo_100006.jpg',
      'model': '宝骏560 2016款 1.8L 手动舒适型',
      'publisher': '123',
      'status_code': 1,
      'updated_at': '2016-10-18 17:22'
    }, {
      'brand': '宝马',
      'come_from': '车主',
      'created_at': '2016-10-18 17:21',
      'id': 3,
      'logo_url': 'https://assets-cdn.cheanjia.com/public/auto-logos/1.0.0/logo_100007.jpg',
      'model': '宝马3系 2016款 320i 时尚型',
      'publisher': '王一',
      'status_code': 1,
      'updated_at': '2016-10-18 17:21'
    }, {
      'brand': '讴歌',
      'come_from': '快修店',
      'created_at': '2016-10-18 17:11',
      'id': 2,
      'logo_url': 'https://assets-cdn.cheanjia.com/public/auto-logos/1.0.0/logo_100106.jpg',
      'model': '讴歌RL 2006款 3.5 AWD',
      'publisher': '阿道夫',
      'status_code': 1,
      'updated_at': '2016-10-18 17:11'
    }, {
      'brand': 'AC Schnitzer',
      'come_from': '车主',
      'created_at': '2016-10-18 17:01',
      'id': 1,
      'logo_url': 'https://assets-cdn.cheanjia.com/public/auto-logos/1.0.0/logo_100000.jpg',
      'model': 'AC Schnitzer X5 2015款 ACS35 35i',
      'publisher': '123',
      'status_code': 1,
      'updated_at': '2016-10-18 17:01'
    }]
  },
  'message': 'ok'
})

Mock.mock(/used-car\/update-used-car/, 'post' + mockSwitch, {
  'code': 0,
  'message': 'ok'
})
